import {
  isLoggedIn,
  projectTitleAutofills,
  ABTEST_LJ1772_VARIANT,
  ABTEST_LJ1772_ON_EXPERIMENT,
} from 'server-data/local-jobs-landing-page';
import { ABTestApi } from '@shared/abtest-api';
import AutofillClickableDropdown from '@shared/autofill-clickable-dropdown';
import createLocalPostProjectForm from '@shared/local-post-project-form';
import { T_ } from '@shared/translation';
import { qtsp } from '@shared/tracking-qtsbinds';
import openLocalOneClickModal from './one-click-modal/index.js';

const localPostProjectForm = createLocalPostProjectForm({
  postProjectFormId: 'hero-local-ppp',
  locationFieldId: 'hero-location-input',
  locationErrorAlertId: 'hero-location-error',
  locationBtnId: 'hero-location-gps',
  onLocationSelected: updateJobHeroTitle,
  postBtn: document.getElementById('job-next'),
  modalID: 'one-click-photography-project-modal',
  isLoggedIn,
  trackingSection: 'Local',
});

const locationStep = createStep(
  'location-step',
  'location-next',
  'hero-location-progress',
  localPostProjectForm.locationField.validate,
);
locationStep.nextButton.setAttribute('type', 'button');
const jobStep = createStep(
  'job-step',
  'job-next',
  'hero-job-progress',
  () => true,
);
const steps = [locationStep, jobStep];
let currentStep = 0;

initNextBtn(0);
bindTrackingEvents();

const navLocation = document.getElementById('navigate-to-location');
navLocation.addEventListener('click', () => {
  showStep(0);
});

const categoryLinks = document.getElementsByClassName('job-category-link');
Array.from(categoryLinks).forEach(linkElement => {
  linkElement.onclick = () => {
    activateABTestLJ1772();
    if (ABTEST_LJ1772_VARIANT === 'test') {
      const linkSubcategoryId = linkElement.dataset.subcategoryId;
      const subcategory = projectTitleAutofills.find(
        jobBundle => jobBundle.subcategory_id === linkSubcategoryId,
      );
      openLocalOneClickModal({
        subcategory,
        isLoggedIn,
      });
      return false;
    }
    return true;
  };
});

function showStep(index) {
  const prevStep = steps[currentStep];
  prevStep.container.classList.add('is-accessibly-hidden');
  prevStep.indicator.classList.remove('is-ProgressSteps-step-current');
  const currStep = steps[index];
  currStep.container.classList.remove('is-accessibly-hidden');
  currStep.indicator.classList.add('is-ProgressSteps-step-current');
  currentStep = index;
}

function initNextBtn(stepIndex) {
  const { nextButton, validate, indicator } = steps[stepIndex];
  nextButton.addEventListener('click', () => {
    if (validate()) {
      showStep(stepIndex + 1);
      indicator.classList.add('is-ProgressSteps-step-completed');
    }
  });
}

let selectedJob = false;
const jobFieldError = document.getElementById('job-field-error');

function validateJob() {
  if (selectedJob) {
    jobFieldError.classList.add('is-hidden');
    return true;
  }
  const postBtn = document.getElementById('job-next');
  postBtn.removeAttribute('disabled');
  jobFieldError.classList.remove('is-hidden');
  return false;
}

let typedSomething = false;
localPostProjectForm.addCondition(validateJob);
const jobInput = document.getElementById('job-input');

jobInput.addEventListener('input', () => {
  selectedJob = false;
  typedSomething = true;
});

const dropDown = new AutofillClickableDropdown({
  inputEl: jobInput,
  dropdownEl: document.getElementById('job-matches'),
  autofillList: projectTitleAutofills.map(formatAutoFillItem),
  autofillSearchOptions: { keys: ['name'], threshold: 0.5 },
  autofillDropdownOptions: {
    showTop: 4,
    prioritiseByField: 'priority',
    uniqueWith: (a, b) =>
      a.name.trim().toLowerCase() === b.name.trim().toLowerCase(),
  },
  onListItemSelectCallback: item => {
    item.save();
    jobFieldError.classList.add('is-hidden');
    selectedJob = true;
    typedSomething = false;
  },
});

jobInput.addEventListener('focusout', () => {
  if (typedSomething) {
    validateJob();
  }
  setTimeout(() => {
    dropDown.hideDropdown();
  }, 500);
});

const jobHeroTitle = document.getElementById('job-hero-title');
function updateJobHeroTitle(geoInfo) {
  jobHeroTitle.innerHTML = T_`Professionals in ${geoInfo.vicinity}`;
}

function createStep(containerId, nextButtonId, indicatorId, validate) {
  const container = document.getElementById(containerId);
  const indicator = document.getElementById(indicatorId);
  const nextButton = document.getElementById(nextButtonId);
  return {
    container,
    nextButton,
    indicator,
    validate,
  };
}

function formatAutoFillItem(content) {
  const { name, save } = createAutoFillConfig(content);
  return {
    name,
    save,
  };
}

function createAutoFillConfig(content) {
  if (content.job_id) {
    return {
      name: `Hire ${content.context_phrase_worker}`,
      save: () => {
        localPostProjectForm.setJob(content);
      },
    };
  }
  return {
    name: content.name,
    save: () => {
      localPostProjectForm.setSubCategory(content);
    },
  };
}

function bindTrackingEvents() {
  const categoryTiles = {
    delivery: 'PickupDelivery',
    photography: 'PhotographyVideography',
    removalist: 'HelpMove',
    cleaning: 'Cleaning',
    gardening: 'Gardening',
  };

  Object.keys(categoryTiles).forEach(category => {
    document
      .getElementById(category)
      .addEventListener('click', () => track(categoryTiles[category]));
  });
}

function track(skill) {
  qtsp.push({
    section: 'LocalJobCategoryUpsellSection',
    subsection: skill,
    label: 'GoToPostProject',
  });
}

function activateABTestLJ1772() {
  if (!ABTEST_LJ1772_ON_EXPERIMENT) {
    return;
  }
  ABTestApi.activateSessionBasedTestSubject(
    'LJ-1772-local-jobs-one-click-home-links',
    ABTEST_LJ1772_VARIANT,
  );
}
